import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Button, Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { isBefore } from 'date-fns'
import { saveAs } from 'file-saver';
import {
  getAsExcelBlob,
  getUnsignedFileBlob
} from '../../actions/admin'
import { copyLinkToClipBoard } from "../../utils/signLink"

const isExpired = (date) => {
  return date && isBefore(new Date(date), new Date())
}

const DocumentActions = ({
  record,
  onEdit,
  onDisableSigning,
  onDelete
}) => {
  const moreActionsDropdown = (
    <Menu>
      <Menu.Item key="0" onClick={() => onEdit(record) }>
        <Button size="small" type="link">
          Edit
        </Button>
      </Menu.Item>
      <Menu.Item key="1" onClick={() => onDisableSigning(record) }>
        <Button size="small" type="link">
          {isExpired(record.endDate) ? "Enable signing" : "Disable signing"}
        </Button>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3" onClick={() => onDelete(record) }>
        <Button size="small" type="link" danger>
          Delete
        </Button>
      </Menu.Item>
    </Menu>
  );
  
  return (
    <Space size="middle">
      <Link to={`/doc/${record._id}`}>
        View data
      </Link>
      <Button size="small" type="link" onClick={() => getUnsignedFileBlob(record._id)
          .then(data => saveAs(data, record.name))
      }>
        Download PDF
      </Button>
      <Button size="small" type="link" onClick={() => getAsExcelBlob(record._id)
          .then(data => saveAs(data, record.name.replace(".pdf", ".xlsx")))
      }>
        Download Excel
      </Button>
      <Button size="small" type="link" onClick={() => copyLinkToClipBoard(record._id) }>
        Copy signing URL
      </Button>
      
      <Dropdown overlay={moreActionsDropdown} trigger={['click']}>
        <Button size="small" type="link" onClick={e => e.preventDefault()}>
          More actions <DownOutlined />
        </Button>
      </Dropdown>
    </Space>
  )
}

export default DocumentActions